import React, { Component } from 'react';
import './reports.css';
import { DataGrid } from '@mui/x-data-grid';
import {
  Box, Button, Checkbox, Drawer, FormControlLabel, IconButton,
  Stack, TextField, Tooltip, Typography
} from '@mui/material';
import { DateTime } from 'luxon';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';
import { ImagePaths } from '../../../Utility/ImagePaths';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import { localGetItem } from '../../../Utility/Services/CacheProviderService';
import { CommonGridToolBarWithFilterText } from '../../../Components/Common Components/CommonComponents';
import { AmountsCard } from '../../../Components/CommonCards/CommonCards';
import { AmountFormat } from '../../../Components/CommonFunctions/CommonFunctions';
import { CurrencySymbol } from '../../../Utility/Constants';
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker';
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation';

class LabPatientServiceReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportList: [],
      pageSize: 10,
      page: 0,
      total: 0,
      totalPatients: 0,
      totalServices: 0,
      grandTotal: 0,
      totalPaidAmt: 0,
      totalPendingAmt: 0,
      cancelBillCount: 0,
      cancelAmount: 0,
      isLoader: false,
      disableBtn: false,

      isErrorMsg: false,
      isErrorMsgText: '',
      isSuccessMsg: false,
      isSuccessMsgText: '',

      FilterOpen: false,
      fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      dateIndex: 1,
      patientName: '',
      accountNumber: '',
      mobileNo: '',
      includeOP: true,
      includeIP: true,
      includeSelf: true,

      billTypeRegular: true,
      billTypeCredit: true,
      billTypeCancelled: true,

      paymentPaid: true,
      paymentNotPaid: true,
      paymentPartial: true,

      isNewBilling: localGetItem('isNewBilling') === 'true',
    };
  }

  buildBillTypeParam = () => {
    const { billTypeRegular, billTypeCredit, billTypeCancelled } = this.state;
    const types = [];
    if (billTypeRegular) types.push('regular');
    if (billTypeCredit) types.push('credit');
    if (billTypeCancelled) types.push('cancelled');
    return types.join(',');
  };

  buildPaymentStatusParam = () => {
    const { paymentPaid, paymentNotPaid, paymentPartial } = this.state;
    const statuses = [];
    if (paymentPaid) statuses.push('paid');
    if (paymentNotPaid) statuses.push('not paid');
    if (paymentPartial) statuses.push('partial');
    return statuses.join(',');
  };

  componentDidMount() {
    if (this.state.isNewBilling) {
      this.getReport();
    }
  }

  msgClose = () => {
    this.setState({
      isErrorMsg: false, isErrorMsgText: '',
      isSuccessMsg: false, isSuccessMsgText: '',
    });
  };

  errorMessage = (msg) => this.setState({ isErrorMsg: true, isErrorMsgText: msg, disableBtn: false });

  buildModuleParam = () => {
    const { includeOP, includeIP, includeSelf } = this.state;
    const mods = [];
    if (includeOP) mods.push('op');
    if (includeIP) mods.push('ip');
    if (includeSelf) mods.push('self');
    return mods.join(',');
  };

  getReport = () => {
    try {
      this.setState({ isLoader: true });
      const { fromDate, toDate, patientName, accountNumber, mobileNo, page, pageSize } = this.state;
      const moduleParam = this.buildModuleParam();
      const billTypeParam = this.buildBillTypeParam();
      const paymentStatusParam = this.buildPaymentStatusParam();

      RestAPIService.getAll(
        Serviceurls.NEW_LAB_PATIENT_SERVICE_REPORT +
        `?page_number=${page + 1}&page_size=${pageSize}` +
        `&from_date=${fromDate}&to_date=${toDate}` +
        `&module_type=${moduleParam}` +
        `&bill_type=${billTypeParam}` +
        `&payment_status=${encodeURIComponent(paymentStatusParam)}` +
        `&patient_name=${patientName}` +
        `&account_number=${accountNumber}` +
        `&mobile_number=${mobileNo}`
      )
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              reportList: response.data.data.result,
              total: response.data.data.total_count,
              totalPatients: response.data.data.total_patients,
              totalServices: response.data.data.total_services,
              grandTotal: response.data.data.grand_total,
              totalPaidAmt: response.data.data.total_paid_amount || 0,
              totalPendingAmt: response.data.data.total_pending_amount || 0,
              cancelBillCount: response.data.data.cancel_bill_count || 0,
              cancelAmount: response.data.data.total_cancel_amount || 0,
              isLoader: false,
            });
          } else {
            this.setState({ isLoader: false });
          }
        })
        .catch((e) => {
          this.setState({ isLoader: false });
          this.errorMessage(e?.response?.data?.message || e.message);
        });
    } catch (e) {
      this.setState({ isLoader: false });
      this.errorMessage(e.message);
    }
  };

  getSummaryPrint = () => {
    try {
      const { fromDate, toDate, patientName, accountNumber, mobileNo } = this.state;
      const moduleParam = this.buildModuleParam();
      const billTypeParam = this.buildBillTypeParam();
      const paymentStatusParam = this.buildPaymentStatusParam();
      this.setState({ disableBtn: true });
      RestAPIService.getAll(
        Serviceurls.NEW_LAB_PATIENT_SERVICE_REPORT +
        `?export_type=pdf` +
        `&from_date=${fromDate}&to_date=${toDate}` +
        `&module_type=${moduleParam}` +
        `&bill_type=${billTypeParam}` +
        `&payment_status=${encodeURIComponent(paymentStatusParam)}` +
        `&patient_name=${patientName}` +
        `&account_number=${accountNumber}` +
        `&mobile_number=${mobileNo}`
      )
        .then((response) => {
          const file = new Blob([response.data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ disableBtn: false });
        })
        .catch((error) => this.errorMessage(error?.response?.data?.message || error.message));
    } catch (error) {
      this.errorMessage(error.message);
    }
  };

  getSummaryExcel = () => {
    try {
      const { fromDate, toDate, patientName, accountNumber, mobileNo } = this.state;
      const moduleParam = this.buildModuleParam();
      const billTypeParam = this.buildBillTypeParam();
      const paymentStatusParam = this.buildPaymentStatusParam();
      this.setState({ disableBtn: true });
      RestAPIService.excelGet(
        Serviceurls.NEW_LAB_PATIENT_SERVICE_REPORT +
        `?export_type=excel` +
        `&from_date=${fromDate}&to_date=${toDate}` +
        `&module_type=${moduleParam}` +
        `&bill_type=${billTypeParam}` +
        `&payment_status=${encodeURIComponent(paymentStatusParam)}` +
        `&patient_name=${patientName}` +
        `&account_number=${accountNumber}` +
        `&mobile_number=${mobileNo}`
      )
        .then((response) => {
          if (response.data) {
            const pom = document.createElement('a');
            const csvContent = response.data;
            const filename = response.headers['content-disposition']
              ? response.headers['content-disposition'].split('filename=')[1]
              : 'registry.xlsx';
            const blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' });
            const url = URL.createObjectURL(blob);
            pom.href = url;
            pom.setAttribute('download', filename);
            pom.click();
            this.setState({ disableBtn: false });
          }
        })
        .catch((error) => this.errorMessage(error?.response?.data?.message || error.message));
    } catch (error) {
      this.errorMessage(error.message);
    }
  };

  getPatientPrint = (row) => {
    try {
      this.setState({ disableBtn: true });
      let idParam = '';
      if (row.identifier_type === 'op_bill') {
        idParam = `&op_bill_id=${row.identifier_id}`;
      } else if (row.identifier_type === 'ip_admission') {
        idParam = `&ip_admission_id=${row.identifier_id}`;
      } else if (row.identifier_type === 'ip_bill') {
        idParam = `&ip_bill_id=${row.identifier_id}`;
      }
      RestAPIService.getAllPrint(
        Serviceurls.NEW_LAB_PATIENT_SERVICE_REPORT +
        `?export_type=pdf` +
        idParam +
        `&from_date=${this.state.fromDate}&to_date=${this.state.toDate}` +
        `&module_type=${this.buildModuleParam()}` +
        `&print_module=${row.module}`
      )
        .then((response) => {
          const file = new Blob([response.data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ disableBtn: false });
        })
        .catch((error) => this.errorMessage(error?.response?.data?.message || error.message));
    } catch (error) {
      this.errorMessage(error.message);
    }
  };

  filterDate = (from, to, index) => {
    this.setState({ fromDate: from, toDate: to, dateIndex: index });
  };

  onChangeHandler = (e, name) => {
    const value = e.target.value;
    switch (name) {
      case 'patientName':
        if (CommonValidation.alphabetOnly(value) || value === '') {
          this.setState({ patientName: value });
        }
        break;
      case 'mobileNo':
        if ((CommonValidation.numberOnly(value) && value.length <= 10) || value === '') {
          this.setState({ mobileNo: value });
        }
        break;
      default:
        this.setState({ [name]: value });
    }
  };

  onCheckBoxHandler = (e, name) => {
    this.setState({ [name]: e.target.checked });
  };

  onClear = () => {
    this.setState({
      fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      dateIndex: 1,
      patientName: '',
      accountNumber: '',
      mobileNo: '',
      includeOP: true,
      includeIP: true,
      includeSelf: true,
      billTypeRegular: true,
      billTypeCredit: true,
      billTypeCancelled: true,
      paymentPaid: true,
      paymentNotPaid: true,
      paymentPartial: true,
      FilterOpen: false,
      page: 0,
      pageSize: 10,
    }, () => this.getReport());
  };

  checkSearch = () => {
    const s = this.state;
    if (!s.includeOP && !s.includeIP && !s.includeSelf) return 'Select at least one module';
    if (!s.billTypeRegular && !s.billTypeCredit && !s.billTypeCancelled) return 'Select at least one bill type';
    if (!s.paymentPaid && !s.paymentNotPaid && !s.paymentPartial) return 'Select at least one payment status';
    return null;
  };

  renderFilterScreen = () => (
    <Box className='eMed_rts_filter_container_New'>
      <Box className='eMed_filter_Top'>
        <Typography variant='h6' fontWeight={600}>{t('Filter')}</Typography>
        <Button onClick={() => this.setState({ FilterOpen: false })} className='eMed_usrconf_btn'>
          <img src={ImagePaths.LabCloseButton.default} alt='close' className='eMed_action_img_small' />
        </Button>
      </Box>
      <Box className='eMed_rts_middle_New'>
        <Box width={'29vw'} sx={{ mt: '0.5vw', display: 'flex', justifyContent: 'flex-end' }}>
          <Box width={'12vw'}>
            <CommonDatePicker
              FromDate={this.state.fromDate}
              ToDate={this.state.toDate}
              DateIndex={this.state.dateIndex}
              SelectedDates={this.filterDate.bind(this)}
              HideAllMenu={true}
            />
          </Box>
        </Box>
        <Box m={'0.5vw'}>
          <Box display={'flex'} mb={'1vw'} mt={'1vw'}>
            <TextField
              size='small'
              sx={{ width: '13.5vw', mr: '0.5vw' }}
              value={this.state.patientName}
              onChange={(e) => this.onChangeHandler(e, 'patientName')}
              label='Patient Name'
              autoComplete='off'
            />
            <TextField
              size='small'
              sx={{ width: '13.5vw', mr: '0.5vw' }}
              value={this.state.accountNumber}
              onChange={(e) => this.onChangeHandler(e, 'accountNumber')}
              label='UHID'
              autoComplete='off'
            />
          </Box>
          <Box>
            <TextField
              size='small'
              sx={{ width: '27.5vw' }}
              value={this.state.mobileNo}
              onChange={(e) => this.onChangeHandler(e, 'mobileNo')}
              label='Mobile Number'
              autoComplete='off'
            />
          </Box>
          <Box mt={'1vw'}>
            <Typography fontWeight={600}>Module Type</Typography>
            <Box display={'flex'}>
              <FormControlLabel checked={this.state.includeOP} control={<Checkbox />} onClick={(e) => this.onCheckBoxHandler(e, 'includeOP')} label='Out Patient' />
              <FormControlLabel checked={this.state.includeIP} control={<Checkbox />} onClick={(e) => this.onCheckBoxHandler(e, 'includeIP')} label='In Patient' />
              <FormControlLabel checked={this.state.includeSelf} control={<Checkbox />} onClick={(e) => this.onCheckBoxHandler(e, 'includeSelf')} label='Self / Lab' />
            </Box>
          </Box>
          <Box mt={'1vw'}>
            <Typography fontWeight={600}>Bill Type</Typography>
            <Box display={'flex'}>
              <FormControlLabel checked={this.state.billTypeRegular} control={<Checkbox />} onClick={(e) => this.onCheckBoxHandler(e, 'billTypeRegular')} label='Regular' />
              <FormControlLabel checked={this.state.billTypeCredit} control={<Checkbox />} onClick={(e) => this.onCheckBoxHandler(e, 'billTypeCredit')} label='Credit' />
              <FormControlLabel checked={this.state.billTypeCancelled} control={<Checkbox />} onClick={(e) => this.onCheckBoxHandler(e, 'billTypeCancelled')} label='Cancelled' />
            </Box>
          </Box>
          <Box mt={'1vw'}>
            <Typography fontWeight={600}>Payment Status</Typography>
            <Box display={'flex'}>
              <FormControlLabel checked={this.state.paymentPaid} control={<Checkbox />} onClick={(e) => this.onCheckBoxHandler(e, 'paymentPaid')} label='Paid' />
              <FormControlLabel checked={this.state.paymentNotPaid} control={<Checkbox />} onClick={(e) => this.onCheckBoxHandler(e, 'paymentNotPaid')} label='Not Paid' />
              <FormControlLabel checked={this.state.paymentPartial} control={<Checkbox />} onClick={(e) => this.onCheckBoxHandler(e, 'paymentPartial')} label='Partial' />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box display={'flex'} justifyContent={'center'}>
        <Button variant='outlined' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw' }} onClick={this.onClear}>Clear</Button>
        <Button variant='contained' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw' }}
          onClick={() => {
            const err = this.checkSearch();
            if (err) {
              this.errorMessage(err);
            } else {
              this.setState({ FilterOpen: false, page: 0 }, () => this.getReport());
            }
          }}
        >Search</Button>
      </Box>
    </Box>
  );

  formatDate(input) {
    const p = input.match(/\d+/g);
    return `${p[2]}-${p[1]}-${p[0]}`;
  }

  gridToolBar = () => {
    const TextArray = [
      { label: 'From Date', value: this.formatDate(this.state.fromDate) },
      { label: 'To Date', value: this.formatDate(this.state.toDate) },
    ];
    return (<Box><CommonGridToolBarWithFilterText FilterTextArray={TextArray} /></Box>);
  };

  render() {
    if (!this.state.isNewBilling) {
      return (
        <div className='reports_container'>
          <Box sx={{ p: '2vw', display: 'flex', justifyContent: 'center' }}>
            <Typography variant='h6'>{t('This report is available only for New Billing.')}</Typography>
          </Box>
        </div>
      );
    }


    const columns = [
      { field: 'sno', headerName: 'S.No', sortable: false, flex: 0.04 },
      { field: 'invoice_date', headerName: 'Date', sortable: false, flex: 0.13, headerAlign: 'center', align: 'center' },
      {
        field: 'patient_name', headerName: 'Patient Name', sortable: false, flex: 0.15,
        renderCell: (params) => {
          const name = params.row.patient_name || '-';
          return name.length > 22
            ? <Tooltip title={name} arrow><div>{name.slice(0, 22) + '...'}</div></Tooltip>
            : <div>{name}</div>;
        },
      },
      { field: 'uhid', headerName: 'UHID', sortable: false, flex: 0.09, headerAlign: 'center', align: 'center' },
      {
        field: 'reference_number', headerName: 'Invoice / IP No.', sortable: false, flex: 0.12, headerAlign: 'center', align: 'center',
        renderCell: (p) => {
          const ref = p.row.reference_number || '-';
          return ref.length > 16
            ? <Tooltip title={ref} arrow><div>{'...' + ref.slice(-14)}</div></Tooltip>
            : <div>{ref}</div>;
        },
      },
      { field: 'mobile_number', headerName: 'Mobile', sortable: false, flex: 0.09, headerAlign: 'center', align: 'center' },
      {
        field: 'module', headerName: 'Module', sortable: false, flex: 0.08, headerAlign: 'center', align: 'center',
        renderCell: (p) => (<div>{p.row.module === 'SELF' ? 'Self / Lab' : p.row.module === 'OP' ? 'Out Patient' : 'In Patient'}</div>),
      },
      { field: 'service_count', headerName: 'Services', sortable: false, flex: 0.06, headerAlign: 'center', align: 'center', type: 'number' },
      {
        field: 'total_amount', headerName: `Total Amount (${CurrencySymbol})`, sortable: false, flex: 0.12, type: 'number',
        renderCell: (p) => (<div>{AmountFormat(p.row.total_amount || 0)?.replace(`${CurrencySymbol}`, '')}</div>),
      },
      {
        field: 'action', headerName: 'Action', sortable: false, flex: 0.06, headerAlign: 'center', align: 'center',
        renderCell: (p) => (
          <IconButton disabled={this.state.disableBtn} onClick={() => this.getPatientPrint(p.row)}>
            <img src={ImagePaths.PrintIcons.default} alt='print' />
          </IconButton>
        ),
      },
    ];

    return (
      <div className='reports_container'>
        <div className='reports_header_card'>
          <div className='reports_bill_left'>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div className='reports_bill_box_one'>
                {AmountsCard(t('Total Bills'), this.state.totalPatients, true)}
              </div>
              <div className='reports_bill_box_one'>
                {AmountsCard(t('Total Services'), this.state.totalServices, true)}
              </div>
              <div className='reports_bill_box_one'>
                {AmountsCard(t('Grand Total'), this.state.grandTotal)}
              </div>
              <div className='reports_bill_box_one'>
                {AmountsCard(t('Total Pending Amount'), this.state.totalPendingAmt)}
              </div>
              <div className='reports_bill_box_one'>
                {AmountsCard(t('Total Paid Amount'), this.state.totalPaidAmt)}
              </div>
              <div className='reports_bill_box_one'>
                {AmountsCard(t('Cancelled Bill Count'), this.state.cancelBillCount, true)}
              </div>
              <div className='reports_bill_box_one'>
                {AmountsCard(t('Cancelled Bill Amount'), this.state.cancelAmount)}
              </div>
            </div>
          </div>
          <div className='reports_right'>
            <img className='reports_print' src={ImagePaths.Filter.default} onClick={() => this.setState({ FilterOpen: true })} alt='Filter' />
            <img className='eMed_rts_upload' src={ImagePaths.LabPrintIcon.default} onClick={() => { if (!this.state.disableBtn) this.getSummaryPrint(); }} alt='print' />
            <img className='eMed_rts_upload' src={ImagePaths.LabUploadButton.default} onClick={() => { if (!this.state.disableBtn) this.getSummaryExcel(); }} alt='upload' />
          </div>
        </div>

        <div className='reports_table_card'>
          <DataGrid
            rows={this.state.reportList}
            rowCount={this.state.total}
            page={this.state.page}
            columns={columns}
            hideFooterSelectedRowCount
            getRowId={(row) => `${row.identifier_type}_${row.identifier_id}`}
            pageSize={this.state.pageSize}
            onPageChange={(newPage) => this.setState({ page: newPage }, () => this.getReport())}
            onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize, page: 0 }, () => this.getReport())}
            rowsPerPageOptions={[10, 20, 30]}
            loading={this.state.isLoader}
            pagination
            paginationMode='server'
            localeText={{ toolbarColumns: '', toolbarDensity: '', toolbarExport: '', toolbarFilters: '', toolbarExportPrint: '' }}
            components={{
              Toolbar: this.gridToolBar,
              NoRowsOverlay: () => (
                <Stack height='100%' alignItems='center' justifyContent='center'>{t('NoRecordsFound')}</Stack>
              ),
            }}
            headerHeight={40}
          />
        </div>

        <Drawer open={this.state.FilterOpen} anchor='right' ModalProps={{ onBackdropClick: () => this.setState({ FilterOpen: false }) }}>
          {this.renderFilterScreen()}
        </Drawer>

        {this.state.isErrorMsg && (
          <ToastMsg severity='error' msg={this.state.isErrorMsgText} msgPop={this.msgClose} />
        )}
        {this.state.isSuccessMsg && (
          <ToastMsg severity='success' msg={this.state.isSuccessMsgText} msgPop={this.msgClose} />
        )}
      </div>
    );
  }
}

export default withTranslation()(LabPatientServiceReport);